/* FizzyIQ — home revamp motion system.
   - [data-rvanim]            scroll-reveal (adds .in-view once, on entry)
   - [data-rvanim-count]      counts the leading integer up on reveal
                              ("20+" → 0..20 keeping the "+"; "100%" likewise)
   - [data-rvanim-parallax]   gentle vertical parallax (±~5%) on scroll
   All no-ops under prefers-reduced-motion. Safe to load once per page;
   re-runs on shopify:section:load for the theme editor. */
(function () {
  'use strict';

  /* Loaded from both the home hero and the site-wide footer — run once. */
  if (window.__fizzyRvMotion) return;
  window.__fizzyRvMotion = 1;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── reveal + count-up ─────────────────────────────────────────────── */

  function countUp(el) {
    var m = (el.textContent || '').trim().match(/^(\d+)(.*)$/);
    if (!m) return;
    var target = parseInt(m[1], 10);
    var suffix = m[2] || '';
    /* Reserve the final-value width before counting so the growing digits can't
       resize the element — otherwise an adjacent label re-wraps and its flex
       column resizes every frame, shaking the section. offsetWidth is read at the
       final text and ignores the entrance transform. Sam 2026-06-24. */
    if (!el.style.minWidth) { el.style.minWidth = el.offsetWidth + 'px'; }
    var t0 = null;
    var DUR = 1000;
    function tick(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / DUR);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initReveals() {
    var els = document.querySelectorAll('[data-rvanim]:not([data-rvanim-bound])');
    if (!els.length) return;
    if (REDUCE || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.setAttribute('data-rvanim-bound', '1');
        el.classList.add('in-view');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('in-view');
        var num = el.hasAttribute('data-rvanim-count') ? el : el.querySelector('[data-rvanim-count]');
        if (num) countUp(num);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -36px 0px' });
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-rvanim-bound', '1');
      io.observe(el);
    });
  }

  /* ── parallax ──────────────────────────────────────────────────────── */

  function initParallax() {
    if (REDUCE) return;
    var layers = Array.prototype.slice.call(document.querySelectorAll('[data-rvanim-parallax]:not([data-rvanim-bound])'));
    if (!layers.length) return;
    layers.forEach(function (el) { el.setAttribute('data-rvanim-bound', '1'); });

    var raf = 0;
    function apply() {
      raf = 0;
      var vh = window.innerHeight;
      layers.forEach(function (el) {
        var host = el.parentElement || el;
        var r = host.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var mid = r.top + r.height / 2 - vh / 2;
        var shift = Math.max(-30, Math.min(30, mid * -0.05));
        el.style.transform = 'translateY(' + shift.toFixed(1) + 'px) scale(1.08)';
      });
    }
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(apply);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    apply();
  }

  /* Site-wide polish (Sam 2026-06-11): give every page the same reveal
     language without per-section markup edits. We auto-tag section-level
     headings that sit BELOW the fold at load — they're off-screen when the
     attribute lands, so there's no flash of hidden content, and above-fold
     copy stays static. Skipped inside fixed/interactive chrome. */
  function autoTag() {
    if (REDUCE) return;
    var fold = window.innerHeight + 40;
    var heads = document.querySelectorAll('main h2:not([data-rvanim]), main .shopify-section h2:not([data-rvanim])');
    Array.prototype.forEach.call(heads, function (el) {
      if (el.closest('[data-rvanim], .fcd-drawer, [hidden], dialog')) return;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.top > fold) el.setAttribute('data-rvanim', '');
    });
  }

  function initAll() {
    autoTag();
    initReveals();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
